<template>
  <div class="wrapper">
    <div class="title">故障名称</div>
    <div class="content">{{name}}（故障码{{code}}）</div>
    <div v-show="isshow">
      <div class="title">故障详情</div>
      <div class="content" v-show="code != 41 && code != 141"><span v-show="code != 100">系统检测到</span>{{nickname}}，车辆可能会出现：{{content}}</div>
      <div class="content" v-show="code == 41 || code == 141">{{content}}</div>
      <div v-show="isshow1">
        <div class="title">处理意见</div>
        <div class="content" v-for="(s,i) in suggestion" :key="i">{{s}}</div>
      </div>
    </div>
    <!-- <div class="title">解决方法</div>
    <div class="content">{{resolvion}}</div> -->
  </div>
</template>

<script>
import data_blueshark from "../assets/js/trouble_blueshark.js"
import data_soloera from "../assets/js/trouble_soloera.js"
export default {
  data(){
    return {
      isshow: false,
      isshow1: false,
      name: "",
      code: "",
      nickname: "",
      content: "",
      suggestion: [],
      resolvion: ""
    }
  },
  mounted(){
    let app = this.$route.query.app
    let code = this.$route.params.tcode
    let ling = "000"
    let data = {}
    if(app == "soloera"){
      data = data_soloera
    } else{
      data = data_blueshark
    }
    this.code = ling.substring(0,3-code.length)+code
    document.title = "故障详情"
    if(data.trouble[code]){
      this.isshow = true
      this.name = data.trouble[code].name
      this.nickname = data.trouble[code].nickname?data.trouble[code].nickname:data.trouble[code].name
      this.content = data.trouble[code].content
      if(data.trouble[code].suggestion !== "暂无"){
        this.isshow1 = true
        this.suggestion = data.trouble[code].suggestion.split("$")
      }      
    } else {
      this.name = "未查到故障详情"
      // this.resolvion = data.trouble[code].resolvion
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper{
  padding: 20px;
  .title{
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .content{
    font-size: 14px;
    color: #969696;
    margin-bottom: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/troubleshoot.vue